/**
 * Production vs test lead collection — must match CRMContext lead reads/writes.
 * Team notes live in `{collection}/{leadId}/comments` (same tree as the lead doc).
 */

export function getLeadsCollectionName(): string {
  if (typeof window !== 'undefined') {
    try {
      if (localStorage.getItem('crm_use_test_leads') === 'true') return 'testLeads';
    } catch {
      /* private mode / quota */
    }
  }
  return 'leads';
}
